import { CommonDataContext } from 'contexts/CommonDataContext';
import { useContext, useEffect, useMemo } from 'react';

export function usePageTitle(pageTitle?: string) {
  const { isDealerUser, isLenderUser, isCommonPartner, isAftermarketPartner } = useContext(CommonDataContext);

  const accountLabel = useMemo(() => {
    if (isAftermarketPartner) return 'Aftermarket Partner Portal';
    if (isCommonPartner) return 'Partner Portal';
    if (isDealerUser) return 'Dealer Portal';
    if (isLenderUser) return 'Lender Portal';
    return 'Dealer Portal';
  }, [isDealerUser, isLenderUser, isCommonPartner, isAftermarketPartner]);

  useEffect(() => {
    document.title = `${accountLabel} | ${pageTitle || 'Transact'}`;
  }, [pageTitle, accountLabel]);
}
